import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from '@tcc/i18n';
import styles from '../cardAndPreview/cardAndPreview.css';
import { toDateString } from '../../../utils/date';
import PreviewNavigationCard from '../cardAndPreview/PreviewNavigationCard';

export function ImportedShapefilePreview({
  activeProperty,
  activeShapefile,
  onLeftClick,
  locale,
  onRightClick,
  isLoading,
}) {
  const property = activeProperty || {};
  const datetime = toDateString(activeShapefile.eventDate, locale);

  return (
    <PreviewNavigationCard
      errorMessage={
        activeProperty === null
          ? getMessage('card.importedShapefile.noData')
          : ''
      }
      isLoading={isLoading}
      onLeftClick={onLeftClick}
      onRightClick={onRightClick}
      testId="dmb-imported-shapefile"
    >
      <div className={styles.column}>
        <div
          className={styles.value}
          data-test-id="imported-shapefile-preview-date"
        >
          {datetime}
        </div>
        <h3 data-test-id="imported-shapefile-preview-property">
          {property.name}
        </h3>
      </div>
    </PreviewNavigationCard>
  );
}

ImportedShapefilePreview.propTypes = {
  activeProperty: PropTypes.object,
  activeShapefile: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  onLeftClick: PropTypes.func.isRequired,
  onRightClick: PropTypes.func.isRequired,
};

export default ImportedShapefilePreview;
